import { forwardRef } from 'react';
import { useSelector } from 'react-redux';
import { ProductRequest } from '../types';
import { Form } from "devextreme-react";
import { GroupItem, SimpleItem } from "devextreme-react/form";
import { getLocalized } from '../../../redux/localization';
import moment from 'moment';

export const renderInformationItem = (item: any) => {
  if (item.editorOptions.value !== null) {
    return <span>{item.editorOptions.value}</span>;
  } else {
    return <span>-</span>;
  }
};

const ProductRequestDetailPage = forwardRef<any, { data: ProductRequest }>(
  ({ data }, ref
  ) => {
    const localize = useSelector(getLocalized);

    return (<form>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
        }}
      >
      </div>
      <Form
        ref={ref}
        key="id"
        labelLocation="left"
        formData={data}
        showColonAfterLabel={true}
      >
        
          <GroupItem caption={"Bilgiler"}>
            <SimpleItem
              dataField="Description"
              label={{
                text: localize.getString("description"),
              }}
              render={renderInformationItem}
            />
            <SimpleItem
              dataField="ProductCategoryName"
              label={{
                text: localize.getString("category"),
              }}
              render={renderInformationItem}
            />
            <SimpleItem
              dataField="Location"
              label={{
                text: localize.getString("location"),
              }}
              render={renderInformationItem}
            />
            <SimpleItem
              dataField="UserName"
              label={{
                text: localize.getString("username"),
              }}
              render={renderInformationItem}
            />
            <SimpleItem
              dataField="CreateTime"
              label={{
                text: localize.getString("creationtime"),
              }}
            

              render={
                (item : any)=> {
                  if (item.editorOptions.value !== null) {
                    return <span>{moment.utc(item.editorOptions.value).format("l")}</span>;
                  } else {
                    return <span>-</span>;
                  }
                }
              }
            />
          </GroupItem>
       
       
      </Form>
    </form>);
  }
)
export default ProductRequestDetailPage;
